import { render, staticRenderFns } from "./Poruke.vue?vue&type=template&id=774d6d60&scoped=true"
import script from "./Poruke.vue?vue&type=script&lang=js"
export * from "./Poruke.vue?vue&type=script&lang=js"
import style0 from "./Poruke.vue?vue&type=style&index=0&id=774d6d60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d6d60",
  null
  
)

export default component.exports